module.exports = __webpack_public_path__ + "img/CS_3_Section_5_train-01.41e7d0c5.png";